import React, { useState, useMemo } from "react";
import {
  Paper,
  Stack,
  TextField,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import { InfoOutlined, History } from "@mui/icons-material";
import { Controller } from "react-hook-form";
import { useVetAttendance } from "@/fluxvet/contexts/VetAttendanceContext";
import { extractGuidelinesHistory } from "@/fluxvet/utils/questionnaireResponseHelper";
import { HistoryModal } from "./HistoryModal";

interface GuidelinesSectionProps {
  control: any;
}

/**
 * Componente de Orientações
 * Campo de texto livre para orientações gerais ao tutor
 */
export const GuidelinesSection: React.FC<GuidelinesSectionProps> = ({
  control,
}) => {
  // Busca o histórico de QuestionnaireResponse do contexto
  const { historyQuestionnaireResponse } = useVetAttendance();

  // Processa o histórico para extrair dados de orientações
  const guidelinesHistory = useMemo(
    () => extractGuidelinesHistory(historyQuestionnaireResponse),
    [historyQuestionnaireResponse]
  );

  // Estado para controlar o modal de histórico
  const [historyModal, setHistoryModal] = useState({
    isOpen: false,
  });

  return (
    <>
    <Stack spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
      <Stack direction="row" alignItems="center" spacing={1}>
        <InfoOutlined sx={{ color: "#00A884" }} />
        <Typography variant="h6" fontWeight={600}>
          Orientações ao Tutor
        </Typography>
          </Stack>
          {guidelinesHistory.length > 0 && (
            <Button
              size="small"
              startIcon={<History />}
              onClick={() => setHistoryModal({ isOpen: true })}
              sx={{
                textTransform: "none",
                fontSize: "0.85rem",
                color: "#666",
                "&:hover": {
                  color: "#00A884",
                  bgcolor: "rgba(0, 168, 132, 0.08)",
                },
              }}
            >
              Ver histórico de orientações
            </Button>
          )}
      </Stack>

      <Paper
        elevation={0}
        sx={{
          p: 2,
          bgcolor: "#fafafa",
          border: "1px solid #e0e0e0",
          borderRadius: 2,
        }}
      >
        <Controller
          name="guidelines"
          control={control}
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              label="Orientações gerais"
              placeholder="Ex: Manter o pet em repouso, oferecer água fresca, observar comportamento nos próximos dias, retornar em caso de piora dos sintomas..."
              multiline
              rows={12}
              error={!!error}
              helperText={error?.message}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  bgcolor: "#fff",
                },
              }}
            />
          )}
        />
      </Paper>
    </Stack>

      {/* Modal de histórico — só exibido quando há histórico */}
      {guidelinesHistory.length > 0 && (
        <HistoryModal
          open={historyModal.isOpen}
          onClose={() => setHistoryModal({ isOpen: false })}
          title="Histórico - Orientações ao Tutor"
          history={guidelinesHistory}
        />
      )}
    </>
  );
};

export default GuidelinesSection;

